module.exports = __webpack_public_path__ + "media/access/review-f0dc9173.png";